import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-100 h-100" }
const _hoisted_2 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Message Details", -1)
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "container-fluid" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "message-heading",
  class: "form-label"
}, "Heading", -1)
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "message-message",
  class: "form-label"
}, "Message", -1)
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "message-message",
  class: "form-label"
}, "Preview", -1)
const _hoisted_14 = { class: "text-center shadow-sm p-2" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer d-flex flex-reverse-row" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-primary",
    form: "message-form"
  }, " Save ")
], -1)
const _hoisted_17 = {
  class: "w-100 h-100 pt-3 container d-flex flex-column",
  style: {"gap":"1px"}
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Messages")
], -1)
const _hoisted_19 = {
  class: "d-flex",
  style: {"gap":"1px"}
}
const _hoisted_20 = { class: "mt-3 p-0 m-0 container-fluid" }
const _hoisted_21 = {
  class: "flex-grow-1 row d-flex",
  style: {"min-height":"0"}
}
const _hoisted_22 = {
  id: "display",
  class: "card h-100 shadow-sm text-center"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "card-title" }
const _hoisted_25 = { class: "card-text" }
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { class: "card-footer text-center" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 0,
  class: "bi bi-pin-fill"
}
const _hoisted_30 = {
  key: 1,
  class: "bi bi-pin-angle-fill"
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1)
const _hoisted_33 = [
  _hoisted_32
]

import Modal from "bootstrap/js/dist/modal";
import {
  listMessage,
  Message,
  saveMessage,
  messageConverter,
  deleteMessage,
} from "@/models/Message";
import { computed, onMounted, ref } from "vue";
import {
  collection,
  query,
  where,
  onSnapshot,
  getFirestore,
} from "firebase/firestore";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let messages = ref<Array<Message>>(Array<Message>());
let selected = ref<Message>(new Message("", "", true));
let search = ref("");

onMounted(() => {
  load();
});

function load() {
  const db = getFirestore();
  const q = query(collection(db, "messages")).withConverter(messageConverter);
  const unsubscribe = onSnapshot(q, (querySnapshot) => {
    messages.value = Array<Message>();
    querySnapshot.forEach((doc) => {
      messages.value.push(doc.data());
    });
  });
}

function selectRecord(message: Message) {
  selected.value = message;
  openModal();
}

function newRecord() {
  selected.value = new Message("", "", true);
  openModal();
}

function saveRecord() {
  saveMessage(selected.value);
}

function deleteRecord(message: Message) {
  deleteMessage(message);
}

function toggleStatus(message: Message) {
  message.isActive = !message.isActive;
  saveMessage(message);
}

function openModal(): void {
  const element = document.getElementById("message-modal") as HTMLElement;
  const messageModal = new Modal(element);
  messageModal.show();
}

function closeModal(): void {
  const element = document.getElementById("message-modal") as HTMLElement;
  const messageModal = new Modal(element);
  messageModal.hide();
}

computed(() => {
  let selected = messages.value.find((i) => i.id == selected.id) as Message;

  if (selected) {
    return messages.value.indexOf(selected);
  } else {
    return -1;
  }
});

const displayedMessages = computed(() => {
  if (search.value.trim() == "") return messages.value;
  
  const searchResult = messages.value.filter(
    (i) =>
      i.header.toUpperCase().includes(search.value.trim().toUpperCase()) ||
      i.message.toUpperCase().includes(search.value.trim().toUpperCase())
  );

  return searchResult;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "modal fade",
      id: "message-modal",
      tabindex: "-1",
      role: "dialog",
      "aria-hidden": "true",
      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (closeModal()), ["self"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (closeModal()))
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("form", {
                id: "message-form",
                onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (saveRecord()), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    name: "message-heading",
                    id: "message-heading",
                    placeholder: "Heading",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(selected).header) = $event))
                  }, null, 512), [
                    [_vModelText, _unref(selected).header]
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _withDirectives(_createElementVNode("textarea", {
                    rows: "10",
                    class: "form-control",
                    name: "message-message",
                    id: "message-message",
                    placeholder: "Message",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(selected).message) = $event))
                  }, null, 512), [
                    [_vModelText, _unref(selected).message]
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", null, [
                      _createElementVNode("h1", null, _toDisplayString(_unref(selected).header), 1)
                    ]),
                    _createElementVNode("div", {
                      innerHTML: _unref(selected).message
                    }, null, 8, _hoisted_15)
                  ])
                ])
              ], 32)
            ])
          ]),
          _hoisted_16
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("button", {
          class: "btn btn-primary btn-sm",
          onClick: _cache[5] || (_cache[5] = () => load())
        }, " Reload "),
        _createElementVNode("button", {
          class: "btn btn-primary btn-sm",
          onClick: _cache[6] || (_cache[6] = () => newRecord())
        }, " New ")
      ]),
      _createElementVNode("div", _hoisted_20, [
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          placeholder: "Search",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(search) ? (search).value = $event : search = $event))
        }, null, 512), [
          [_vModelText, _unref(search)]
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayedMessages), (message) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-md-4 p-1",
            key: message.id,
            style: {"max-height":"500px","cursor":"pointer"}
          }, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", {
                class: "card-body flex-grow-1",
                onClick: ($event: any) => (selectRecord(message)),
                style: {"overflow-y":"auto"}
              }, [
                _createElementVNode("h3", _hoisted_24, _toDisplayString(message.header), 1),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", {
                    innerHTML: message.message
                  }, null, 8, _hoisted_26)
                ])
              ], 8, _hoisted_23),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("button", {
                  class: _normalizeClass(`btn btn-${
                  message.isActive ? 'success' : 'outline-secondary'
                } btn-sm mx-1`),
                  focusable: "false",
                  onClick: ($event: any) => (toggleStatus(message))
                }, [
                  (message.isActive == false)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_29))
                    : _createCommentVNode("", true),
                  (message.isActive == true)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_30))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_28),
                _createElementVNode("button", {
                  class: "btn btn-outline-danger btn-sm mx-1",
                  focusable: "false",
                  onClick: ($event: any) => (deleteRecord(message))
                }, _hoisted_33, 8, _hoisted_31)
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})